<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>

    <button class="close" type="button" aria-label="Close" [disabled]="isBusy" (click)="activeModal.close(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="upload-wrapper">
    <kendo-fileselect
        [restrictions]="attachmentFileUploadRestrictions"
        [multiple]="true"
        (select)="fileSelected($event)"
        (remove)="fileRemoved($event)"></kendo-fileselect>

    @if (!isRestrictionsLoaded) {
    <div class="upload-overlay">
        <div class="overlay-content">{{ 'Loading upload settings...' | translate }}</div>
    </div>
    }
</div>

<div class="modal-footer">
    @if (files.length > 0) {
    <button class="btn btn-sm btn-primary mr-2" [disabled]="isBusy" (click)="finish()">
        <fa-icon [icon]="['fas', 'check']"></fa-icon>
        &nbsp;&nbsp;{{ yesButtonName }}
    </button>
    }
    <button class="btn btn-sm btn-secondary" [disabled]="isBusy" (click)="activeModal.close(null)">
        <fa-icon [icon]="['fas', 'times']"></fa-icon>
        &nbsp;&nbsp;{{ 'Cancel' | translate }}
    </button>
</div>
